/** Google Ads 779 website tag helpers for PC Web. Do not import App IAP IDs. */

export const GOOGLE_ADS_AW_ID = 'AW-18439723089'
const CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'] as const
const STORAGE_PREFIX = 'pc_attr_'

function readQuery(): URLSearchParams {
  try {
    return new URLSearchParams(window.location.search || '')
  } catch {
    return new URLSearchParams()
  }
}

export function persistPcAttributionFromUrl(): void {
  const query = readQuery()
  for (const key of CLICK_KEYS) {
    const value = String(query.get(key) || '').trim()
    if (!value) continue
    try {
      sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, value)
    } catch {
      // ignore storage failures
    }
  }
}

function readStored(key: string): string {
  try {
    return String(sessionStorage.getItem(`${STORAGE_PREFIX}${key}`) || '').trim()
  } catch {
    return ''
  }
}

export function h5UrlWithAttribution(base: string): string {
  persistPcAttributionFromUrl()
  const url = new URL(base)
  const query = readQuery()
  for (const key of CLICK_KEYS) {
    const value = String(query.get(key) || readStored(key) || '').trim()
    if (!value || url.searchParams.has(key)) continue
    url.searchParams.set(key, value)
  }
  return url.toString()
}
